import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const [legalModal, setLegalModal] = useState<'terms' | 'privacy' | null>(null);
  const {
    t
  } = useLanguage();
  return <>
      <footer className="py-16 px-6 bg-black" data-id="element-77">
        <div className="max-w-7xl mx-auto" data-id="element-78">
          <div className="flex flex-col items-center text-center" data-id="element-79">
            {/* Logo */}
            <h3 className="font-serif text-2xl text-white mb-6" data-id="element-80">
              Alexaaa Narvaez
            </h3>

            {/* Divider */}
            <div className="w-full max-w-xs h-px bg-white/10 mb-8" data-id="element-81" />

            {/* Copyright */}
            <p className="text-white/40 text-sm font-light" data-id="element-82">
              © 2025 Alexaaa Narvaez. {t('footer.rights')}
            </p>

            {/* Legal Links */}
            <div className="flex items-center gap-6 mt-4" data-id="element-83">
              <button onClick={() => setLegalModal('terms')} className="text-white/40 text-xs hover:text-white/60 transition-colors cursor-pointer" data-id="element-84">
                {t('footer.terms')}
              </button>
              <button onClick={() => setLegalModal('privacy')} className="text-white/40 text-xs hover:text-white/60 transition-colors cursor-pointer" data-id="element-85">
                {t('footer.privacy')}
              </button>
            </div>

            {/* Age Disclaimer */}
            <p className="text-white/30 text-xs mt-6 max-w-md" data-id="element-86">
              {t('footer.age')}
            </p>
          </div>
        </div>
      </footer>

      {/* Legal Modals */}
      <LegalModal isOpen={legalModal !== null} onClose={() => setLegalModal(null)} type={legalModal || 'terms'} data-id="element-87" />
    </>;
}